import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
    IoStorefrontOutline,
    IoListOutline,
    IoHomeOutline,
    IoCartOutline,
} from "react-icons/io5";
import { RiGroupLine } from "react-icons/ri";

import "./bottomNav.css";

function ListItem({ icon, text, to, selected, onClick }) {
    return (
        <li className={`list ${selected && "active"}`} onClick={onClick}>
            <NavLink to={to} activeClassName="active">
                <span className="icon">{icon}</span>
                <span className="text">{text}</span>
            </NavLink>
        </li>
    );
}

export default function BottomNav() {
    const [selected, setSelected] = useState("Home");
    const handleClick = (item) => {
        setSelected(item);
    };

    return (
        <div className="flex-1 justify-center items-center hidden sm:flex md:flex">
            <div className="navigation">
                <ul>
                    <ListItem
                        icon={<IoListOutline />}
                        text="Categories"
                        to="/categories"
                        selected={selected === "Categories"}
                        onClick={() => handleClick("Categories")}
                    />
                    <ListItem
                        icon={<IoStorefrontOutline className="h-5 w-5"/>}
                        text="Products"
                        to="/products"
                        selected={selected === "Products"}
                        onClick={() => handleClick("Products")}
                    />
                    <ListItem
                        icon={<IoHomeOutline />}
                        text="Home"
                        to="/"
                        selected={selected === "Home"}
                        onClick={() => handleClick("Home")}
                    />
                    <ListItem
                        icon={<IoCartOutline />}
                        text="Cart"
                        to="/card"
                        selected={selected === "Cart"}
                        onClick={() => handleClick("Cart")}
                    />
                    <ListItem
                        icon={<RiGroupLine className="h-5 w-5"/>}
                        text="Sellers"
                        to="/sellers"
                        selected={selected === "Sellers"}
                        onClick={() => handleClick("Sellers")}
                    />
                    <div className="indicator"></div>
                </ul>
            </div>
        </div>
    );
}
